import { useState } from "react";
import { ArrowLeft, Copy, Camera, Check } from "lucide-react";
import Input from "../components/Input";
import BackHeader from "../components/BackHeader";
import { Icons } from "../assets/icons/Icons";
import PhoneInput from "../components/PhoneInput";
// import { ProfilePictureModal } from "../components/ProfilePictureModal";
import ProfilePictureModal from "../components/ProfilePictureModal";

const ProfilePage = () => {
    const [profileData, setProfileData] = useState({
        idNumber: "1259 9484 1548",
        firstName: "Alexander",
        lastName: "Quinn",
        birthDate: "12/27/1995",
        email: "Alexandra@gmail.com",
        phoneNumber: "+1259 9484 1548",
        countryCode: "US",
    });

    const [showModal, setShowModal] = useState(false);
    const [profileImage, setProfileImage] = useState(
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Account-2ETemGCgxU3qokcpHzK5BCXCGnhXZd.png"
    );
    const [userName, setUserName] = useState("Alexandra Alexa");

    const handleShow = (newImage) => {
        setShowModal(!showModal);
    };

    const handleSave = (newImage) => {
        setProfileImage(newImage);
        console.log("Profile picture updated!");
    };

    const [phoneData, setPhoneData] = useState({
        phoneNumber: "+1259 9484 1548",
        countryCode: "US",
    });

    const handlePhoneChange = (e) => {
        setPhoneData({
            ...phoneData,
            phoneNumber: e.target.value,
        });
    };

    const handleCountryChange = (code) => {
        setPhoneData({
            ...phoneData,
            countryCode: code,
        });
    };

    const handleChange = (field, value) => {
        setProfileData({
            ...profileData,
            [field]: value,
        });
    };

    const handleUpdate = () => {
        console.log("Profile updated:", profileData);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        alert("Copied to clipboard!");
    };

    return (
        <div
            className="min-vh-100 d-flex flex-column"
            // style={{
            //     padding: "20px",
            // }}
        >
            <ProfilePictureModal
                show={true}
                onClose={handleShow}
                name={userName}
                profileImage={profileImage}
                onSave={handleSave}
            />
            {/* Header */}
            <BackHeader title="My Profile" />
            {/* Profile Picture */}
            <div className="d-flex justify-content-center mb-4 mt-3qq">
                <div className="position-relative">
                    <img
                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/profile-XOKZ75Fzfnrp7nLZPedGbofVIPIloD.png"
                        alt="Profile"
                        className="rounded-circle"
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            border: "3px solid rgba(255, 255, 255, 0.2)",
                        }}
                    />
                    <div
                        data-bs-toggle="offcanvas"
                        data-bs-target="#menu-notifications"
                        onClick={handleShow}
                        className="position-absolute bottom-0 end-0 rounded-circle d-flex justify-content-center align-items-center"
                        style={{
                            width: "36px",
                            height: "36px",
                            cursor: "pointer",
                        }}
                    >
                        <Icons.CameraEditIcon />
                    </div>
                </div>
            </div>
            {/* Form */}
            <div
                className="container px-3"
                style={{
                    padding: "20px",
                }}
            >
                {/* ID Number */}
                <div className="mb-4">
                    <label className="mb-1 font-600">ID NUMBER</label>
                    <div
                        className="form-control form-control-lg border-0 text-white rounded-3 d-flex justify-content-between align-items-center"
                        style={{
                            height: "50px",
                            backgroundColor: "rgba(30, 30, 30, 1)",
                        }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            <Icons.UserIdIcon />
                            <span style={{ fontSize: 16 }}>
                                {profileData.idNumber}
                            </span>
                        </div>
                        <div
                            onClick={() =>
                                copyToClipboard(profileData.idNumber)
                            }
                            style={{ cursor: "pointer" }}
                        >
                            <Icons.CopyIcon />
                        </div>
                    </div>
                </div>

                {/* Name Fields */}
                <div className="row g-3 mb-4">
                    <div className="col-6">
                        <Input
                            label="FIRST NAME"
                            id="firstName"
                            value={profileData.firstName}
                            onChange={(e) =>
                                handleChange("firstName", e.target.value)
                            }
                            bgType="gray"
                        />
                    </div>
                    <div className="col-6">
                        <Input
                            label="LAST NAME"
                            id="lastName"
                            value={profileData.lastName}
                            onChange={(e) =>
                                handleChange("lastName", e.target.value)
                            }
                            bgType="gray"
                        />
                    </div>
                </div>

                {/* Birth Date */}
                <Input
                    label="BIRTH OF DATE"
                    id="birthDate"
                    value={profileData.birthDate}
                    onChange={(e) => handleChange("birthDate", e.target.value)}
                    active={true}
                    bgType="gray"
                    // type="date"
                />

                {/* Email */}
                <Input
                    label="E-MAIL"
                    id="email"
                    type="email"
                    value={profileData.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                    active={true}
                    bgType="gray"
                />

                {/* Phone Number */}

                <PhoneInput
                    value={phoneData.phoneNumber}
                    onChange={handlePhoneChange}
                    countryCode={phoneData.countryCode}
                    onCountryChange={handleCountryChange}
                    active={true}
                    bgType="gray"
                />

                {/* Update Button */}
                <div
                    className="d-flex justify-content-center align-items-center mt-5"
                    style={{
                        backgroundColor: "#2E2CB2",
                        color: "white",
                        height: "56px",
                        borderRadius: "12px",
                        fontSize: "18px",
                        fontWeight: "600",
                    }}
                    onClick={handleUpdate}
                >
                    Update
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
